export default __webpack_public_path__ + "static/63-74aaed25df1f34ed5e7fe0de384f94f6.gif";